/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ResponseListGetUserPointsOptionRespVo,
  ResponseLong,
  ResponsePageDataGetAdminUserPointsDetailPageListRespVo,
  ResponsePageDataGetAdminUserPointsPageListRespVo,
  ResponsePageDataGetUserPointsHistoryPageRespVo,
  ResponsePageDataUserPointsHistoryRespVo,
  ResponseString,
  ResponseUserPointsInfoRespVo,
  SetUserPointActionReqVo,
  UserPointActionReqVo,
  UserPointFreezeActionReqVo,
  UserPointsCreateReqVo,
  UserPointsHistoryCreateReqVo,
  UserPointsUpdateReqVo,
} from '../models/index';
import {
    ResponseListGetUserPointsOptionRespVoFromJSON,
    ResponseListGetUserPointsOptionRespVoToJSON,
    ResponseLongFromJSON,
    ResponseLongToJSON,
    ResponsePageDataGetAdminUserPointsDetailPageListRespVoFromJSON,
    ResponsePageDataGetAdminUserPointsDetailPageListRespVoToJSON,
    ResponsePageDataGetAdminUserPointsPageListRespVoFromJSON,
    ResponsePageDataGetAdminUserPointsPageListRespVoToJSON,
    ResponsePageDataGetUserPointsHistoryPageRespVoFromJSON,
    ResponsePageDataGetUserPointsHistoryPageRespVoToJSON,
    ResponsePageDataUserPointsHistoryRespVoFromJSON,
    ResponsePageDataUserPointsHistoryRespVoToJSON,
    ResponseStringFromJSON,
    ResponseStringToJSON,
    ResponseUserPointsInfoRespVoFromJSON,
    ResponseUserPointsInfoRespVoToJSON,
    SetUserPointActionReqVoFromJSON,
    SetUserPointActionReqVoToJSON,
    UserPointActionReqVoFromJSON,
    UserPointActionReqVoToJSON,
    UserPointFreezeActionReqVoFromJSON,
    UserPointFreezeActionReqVoToJSON,
    UserPointsCreateReqVoFromJSON,
    UserPointsCreateReqVoToJSON,
    UserPointsHistoryCreateReqVoFromJSON,
    UserPointsHistoryCreateReqVoToJSON,
    UserPointsUpdateReqVoFromJSON,
    UserPointsUpdateReqVoToJSON,
} from '../models/index';

export interface UserPointsAddPostRequest {
    userPointActionReqVo?: UserPointActionReqVo;
}

export interface UserPointsAdminAddDeductPostRequest {
    setUserPointActionReqVo?: SetUserPointActionReqVo;
}

export interface UserPointsAdminDetailPageListGetRequest {
    currentPage: number;
    pageSize: number;
    startTime?: string;
    endTime?: string;
    changeReason?: number;
    name?: string;
    code?: string;
    remark?: string;
}

export interface UserPointsAdminPageListGetRequest {
    currentPage: number;
    pageSize: number;
    name?: string;
    code?: string;
    sortField?: string;
    sort?: string;
}

export interface UserPointsCurrentHistoryGetRequest {
    currentPage: number;
    pageSize: number;
    changeReason?: number;
    startTime?: string;
    endTime?: string;
}

export interface UserPointsDeductPostRequest {
    userPointActionReqVo?: UserPointActionReqVo;
}

export interface UserPointsFreezePostRequest {
    userPointFreezeActionReqVo?: UserPointFreezeActionReqVo;
}

export interface UserPointsHistoryListGetRequest {
    currentPage: number;
    pageSize: number;
    keyword?: string;
    enable?: number;
    intOutType?: number;
    userId?: number;
    startTime?: string;
    endTime?: string;
}

export interface UserPointsHistoryPostRequest {
    userPointsHistoryCreateReqVo?: UserPointsHistoryCreateReqVo;
}

export interface UserPointsIdDeleteRequest {
    id: number;
}

export interface UserPointsIdGetRequest {
    id: number;
}

export interface UserPointsIdPutRequest {
    id: number;
    userPointsUpdateReqVo?: UserPointsUpdateReqVo;
}

export interface UserPointsPostRequest {
    userPointsCreateReqVo?: UserPointsCreateReqVo;
}

export interface UserPointsUnfreezePostRequest {
    userPointFreezeActionReqVo?: UserPointFreezeActionReqVo;
}

export interface UserPointsUserUserIdGetRequest {
    userId: number;
}

/**
 * 
 */
export class UserPointsControllerApi extends runtime.BaseAPI {

    /**
     * 增加积分 增加积分 为用户增加指定积分
     * 增加积分
     */
    async userPointsAddPostRaw(requestParameters: UserPointsAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-points/add`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserPointActionReqVoToJSON(requestParameters['userPointActionReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 增加积分 增加积分 为用户增加指定积分
     * 增加积分
     */
    async userPointsAddPost(requestParameters: UserPointsAddPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.userPointsAddPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 发放/扣减积分
     * 发放/扣减积分
     */
    async userPointsAdminAddDeductPostRaw(requestParameters: UserPointsAdminAddDeductPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-points/admin/add-deduct`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetUserPointActionReqVoToJSON(requestParameters['setUserPointActionReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 发放/扣减积分
     * 发放/扣减积分
     */
    async userPointsAdminAddDeductPost(requestParameters: UserPointsAdminAddDeductPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.userPointsAdminAddDeductPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 积分使用明细分页列表
     * 积分使用明细分页列表
     */
    async userPointsAdminDetailPageListGetRaw(requestParameters: UserPointsAdminDetailPageListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataGetAdminUserPointsDetailPageListRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling userPointsAdminDetailPageListGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling userPointsAdminDetailPageListGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        if (requestParameters['changeReason'] != null) {
            queryParameters['changeReason'] = requestParameters['changeReason'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['remark'] != null) {
            queryParameters['remark'] = requestParameters['remark'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-points/admin/detail/page-list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataGetAdminUserPointsDetailPageListRespVoFromJSON(jsonValue));
    }

    /**
     * 积分使用明细分页列表
     * 积分使用明细分页列表
     */
    async userPointsAdminDetailPageListGet(requestParameters: UserPointsAdminDetailPageListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataGetAdminUserPointsDetailPageListRespVo> {
        const response = await this.userPointsAdminDetailPageListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * --管理端接口-- 获取用户积分信息分页列表
     * 获取用户积分信息分页列表
     */
    async userPointsAdminPageListGetRaw(requestParameters: UserPointsAdminPageListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataGetAdminUserPointsPageListRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling userPointsAdminPageListGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling userPointsAdminPageListGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['sortField'] != null) {
            queryParameters['sortField'] = requestParameters['sortField'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-points/admin/page-list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataGetAdminUserPointsPageListRespVoFromJSON(jsonValue));
    }

    /**
     * --管理端接口-- 获取用户积分信息分页列表
     * 获取用户积分信息分页列表
     */
    async userPointsAdminPageListGet(requestParameters: UserPointsAdminPageListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataGetAdminUserPointsPageListRespVo> {
        const response = await this.userPointsAdminPageListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 获取积分历史记录列表 使用区分 筛选项列表
     * 获取积分历史记录列表 使用区分 筛选项列表
     */
    async userPointsChangeReasonsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListGetUserPointsOptionRespVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-points/change-reasons`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListGetUserPointsOptionRespVoFromJSON(jsonValue));
    }

    /**
     * 获取积分历史记录列表 使用区分 筛选项列表
     * 获取积分历史记录列表 使用区分 筛选项列表
     */
    async userPointsChangeReasonsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListGetUserPointsOptionRespVo> {
        const response = await this.userPointsChangeReasonsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * -----为客户端提供接口---- 获取当前登录用户积分值
     * 获取当前登录用户积分值
     */
    async userPointsCurrentGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUserPointsInfoRespVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-points/current`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUserPointsInfoRespVoFromJSON(jsonValue));
    }

    /**
     * -----为客户端提供接口---- 获取当前登录用户积分值
     * 获取当前登录用户积分值
     */
    async userPointsCurrentGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUserPointsInfoRespVo> {
        const response = await this.userPointsCurrentGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 获取当前登录用户积分使用记录列表(分页)
     * 获取当前登录用户积分使用记录列表(分页)
     */
    async userPointsCurrentHistoryGetRaw(requestParameters: UserPointsCurrentHistoryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataGetUserPointsHistoryPageRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling userPointsCurrentHistoryGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling userPointsCurrentHistoryGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['changeReason'] != null) {
            queryParameters['changeReason'] = requestParameters['changeReason'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-points/current/history`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataGetUserPointsHistoryPageRespVoFromJSON(jsonValue));
    }

    /**
     * 获取当前登录用户积分使用记录列表(分页)
     * 获取当前登录用户积分使用记录列表(分页)
     */
    async userPointsCurrentHistoryGet(requestParameters: UserPointsCurrentHistoryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataGetUserPointsHistoryPageRespVo> {
        const response = await this.userPointsCurrentHistoryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 扣除积分 扣除积分 为用户扣除指定积分
     * 扣除积分
     */
    async userPointsDeductPostRaw(requestParameters: UserPointsDeductPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-points/deduct`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserPointActionReqVoToJSON(requestParameters['userPointActionReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 扣除积分 扣除积分 为用户扣除指定积分
     * 扣除积分
     */
    async userPointsDeductPost(requestParameters: UserPointsDeductPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.userPointsDeductPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 冻结积分 冻结积分 冻结用户指定积分
     * 冻结积分
     */
    async userPointsFreezePostRaw(requestParameters: UserPointsFreezePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-points/freeze`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserPointFreezeActionReqVoToJSON(requestParameters['userPointFreezeActionReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 冻结积分 冻结积分 冻结用户指定积分
     * 冻结积分
     */
    async userPointsFreezePost(requestParameters: UserPointsFreezePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.userPointsFreezePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 分页查询用户积分记录 分页查询用户积分记录
     * 分页查询用户积分记录
     */
    async userPointsHistoryListGetRaw(requestParameters: UserPointsHistoryListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataUserPointsHistoryRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling userPointsHistoryListGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling userPointsHistoryListGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['keyword'] != null) {
            queryParameters['keyword'] = requestParameters['keyword'];
        }

        if (requestParameters['enable'] != null) {
            queryParameters['enable'] = requestParameters['enable'];
        }

        if (requestParameters['intOutType'] != null) {
            queryParameters['intOutType'] = requestParameters['intOutType'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-points/history/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataUserPointsHistoryRespVoFromJSON(jsonValue));
    }

    /**
     * 分页查询用户积分记录 分页查询用户积分记录
     * 分页查询用户积分记录
     */
    async userPointsHistoryListGet(requestParameters: UserPointsHistoryListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataUserPointsHistoryRespVo> {
        const response = await this.userPointsHistoryListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 创建用户积分流水 创建用户积分流水
     * 创建用户积分流水
     */
    async userPointsHistoryPostRaw(requestParameters: UserPointsHistoryPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-points/history`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserPointsHistoryCreateReqVoToJSON(requestParameters['userPointsHistoryCreateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 创建用户积分流水 创建用户积分流水
     * 创建用户积分流水
     */
    async userPointsHistoryPost(requestParameters: UserPointsHistoryPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.userPointsHistoryPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 删除积分信息 删除积分信息 逻辑删除指定积分编号的积分信息
     * 删除积分信息
     */
    async userPointsIdDeleteRaw(requestParameters: UserPointsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userPointsIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-points/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 删除积分信息 删除积分信息 逻辑删除指定积分编号的积分信息
     * 删除积分信息
     */
    async userPointsIdDelete(requestParameters: UserPointsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.userPointsIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 获取指定用户积分编号的积分信息 指定积分数据编号的获取积分信息
     * 指定积分数据编号的获取积分信息
     */
    async userPointsIdGetRaw(requestParameters: UserPointsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUserPointsInfoRespVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userPointsIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-points/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUserPointsInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 获取指定用户积分编号的积分信息 指定积分数据编号的获取积分信息
     * 指定积分数据编号的获取积分信息
     */
    async userPointsIdGet(requestParameters: UserPointsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUserPointsInfoRespVo> {
        const response = await this.userPointsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 修改积分信息 修改积分信息 更新指定积分编号的积分信息
     * 修改积分信息
     */
    async userPointsIdPutRaw(requestParameters: UserPointsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userPointsIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-points/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserPointsUpdateReqVoToJSON(requestParameters['userPointsUpdateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 修改积分信息 修改积分信息 更新指定积分编号的积分信息
     * 修改积分信息
     */
    async userPointsIdPut(requestParameters: UserPointsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.userPointsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 创建积分信息 创建积分信息 为新用户创建积分账户
     * 创建积分信息
     */
    async userPointsPostRaw(requestParameters: UserPointsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-points`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserPointsCreateReqVoToJSON(requestParameters['userPointsCreateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 创建积分信息 创建积分信息 为新用户创建积分账户
     * 创建积分信息
     */
    async userPointsPost(requestParameters: UserPointsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.userPointsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 解冻积分 解冻积分 解冻用户指定积分
     * 解冻积分
     */
    async userPointsUnfreezePostRaw(requestParameters: UserPointsUnfreezePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-points/unfreeze`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserPointFreezeActionReqVoToJSON(requestParameters['userPointFreezeActionReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 解冻积分 解冻积分 解冻用户指定积分
     * 解冻积分
     */
    async userPointsUnfreezePost(requestParameters: UserPointsUnfreezePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.userPointsUnfreezePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 按用户 ID 查询积分信息 按用户 ID 查询 根据用户 ID 查询积分详情
     * 按用户 ID 查询
     */
    async userPointsUserUserIdGetRaw(requestParameters: UserPointsUserUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUserPointsInfoRespVo>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userPointsUserUserIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-points/user/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUserPointsInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 按用户 ID 查询积分信息 按用户 ID 查询 根据用户 ID 查询积分详情
     * 按用户 ID 查询
     */
    async userPointsUserUserIdGet(requestParameters: UserPointsUserUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUserPointsInfoRespVo> {
        const response = await this.userPointsUserUserIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
